import { useMutation } from '@tanstack/react-query';
import { formsService } from '../api/forms.service';

/**
 * Triggers a CSV download for a form's submissions. Modeled after
 * `shared/lib/download.ts` but reads directly from the export endpoint
 * instead of a stored file key.
 */
export function useExportSubmissions(formId: string, filenamePrefix: string) {
  return useMutation({
    mutationFn: async () => {
      const { data } = await formsService.exportSubmissionsCsv(formId);
      const url = URL.createObjectURL(data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${filenamePrefix}-${formId}.csv`;
      anchor.click();
      URL.revokeObjectURL(url);
    },
  });
}
